(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    // Show More / Show Less Toggle Logic
    const showMoreToggles = document.querySelectorAll('[data-show-more-toggle]');

    showMoreToggles.forEach((toggle) => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        const childMenuList = toggle.closest('.mobile-child-menu-list');
        if (!childMenuList) return;

        const hiddenItems = childMenuList.querySelectorAll('[data-show-more-item]');
        const moreText = toggle.querySelector('.mobile-child-menu-show-more__text--more');
        const lessText = toggle.querySelector('.mobile-child-menu-show-more__text--less');

        // If currently showing "Show More" (items hidden), we want to show them
        // Items have 'hidden' attribute initially
        const isCurrentlyHidden = hiddenItems.length > 0 && hiddenItems[0].hasAttribute('hidden');

        if (isCurrentlyHidden) {
          // Show items
          hiddenItems.forEach((item) => item.removeAttribute('hidden'));
          if (moreText) moreText.hidden = true;
          if (lessText) lessText.hidden = false;
        } else {
          // Hide items
          hiddenItems.forEach((item) => item.setAttribute('hidden', ''));
          if (moreText) moreText.hidden = false;
          if (lessText) lessText.hidden = true;
        }
      });
    });

    // Toggle menu-overflow class when submenu opens/closes
    const menuDrawer = document.querySelector('[data-header-drawer]');
    if (!menuDrawer) return;

    function updateMenuOverflowClass() {
      // Check if any submenu is open
      const openSubmenu = menuDrawer.querySelector('.mobile-menu-item-wrapper > details[open]');
      
      if (openSubmenu) {
        menuDrawer.classList.add('menu-overflow');
      } else {
        menuDrawer.classList.remove('menu-overflow');
      }
    }

    // Watch for changes to details elements (submenu open/close)
    const menuItemDetails = menuDrawer.querySelectorAll('.mobile-menu-item-wrapper > details');
    
    menuItemDetails.forEach((details) => {
      // Listen for toggle events
      details.addEventListener('toggle', updateMenuOverflowClass);
    });

    // Initial check
    updateMenuOverflowClass();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["list-filter"] && !Shopify.designMode) return;
  try {
    const removeDrawerSearchInputs = () => {
    if (!window.matchMedia('(min-width: 750px)').matches) return;

    const drawerSearchWrappers = document.querySelectorAll(
      '.facets-drawer__options-content .facets__search-wrapper'
    );

    for (const wrapper of drawerSearchWrappers) {
      wrapper.remove();
    }
  };

  removeDrawerSearchInputs();

  const drawerSearchCleanupQuery = window.matchMedia('(min-width: 750px)');
  if (typeof drawerSearchCleanupQuery.addEventListener === 'function') {
    drawerSearchCleanupQuery.addEventListener('change', removeDrawerSearchInputs);
  } else {
    drawerSearchCleanupQuery.addListener(removeDrawerSearchInputs);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu-list copy"] && !Shopify.designMode) return;
  try {
    if (!window.__megaMenuReadMoreInitialized) {
    window.__megaMenuReadMoreInitialized = true;

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const toggle = event.target.closest('[data-readmore-toggle]');
      if (!toggle) return;
      if (toggle.tagName === 'A') {
        event.preventDefault();
      }

      const listId = toggle.getAttribute('aria-controls');
      const list = listId ? document.getElementById(listId) : toggle.closest('[data-readmore-list]');
      if (!list) return;

      const limitValue = list.getAttribute('data-readmore-limit');
      const limit = limitValue ? parseInt(limitValue, 10) : 10;
      const expanded = list.getAttribute('data-readmore-expanded') === 'true';
      const nextExpanded = !expanded;

      list.setAttribute('data-readmore-expanded', nextExpanded.toString());
      toggle.setAttribute('aria-expanded', nextExpanded.toString());

      const moreText = toggle.getAttribute('data-readmore-more') || 'Show all';
      const lessText = toggle.getAttribute('data-readmore-less') || 'Show less';
      toggle.textContent = nextExpanded ? lessText : moreText;

      let index = 0;
      const items = list.querySelectorAll('[data-readmore-item]');
      for (const item of items) {
        if (!(item instanceof HTMLElement)) continue;
        if (index >= limit) {
          item.hidden = !nextExpanded;
        }
        index += 1;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu-list-1"] && !Shopify.designMode) return;
  try {
    function applyScrollableScroll(container,direction){const items=Array.from(container.querySelectorAll("[data-scroll-item]")),limit=parseInt(container.getAttribute("data-scroll-limit")||"6",10);let currentStartIndex=0;for(let i=0;i<items.length;i++)if("none"!==items[i].style.display){currentStartIndex=i;break}const newStartIndex="up"===direction?Math.max(0,currentStartIndex-1):Math.min(items.length-limit,currentStartIndex+1);items.forEach((item,index)=>{item.style.display=index>=newStartIndex&&index<newStartIndex+limit?"":"none"});const scrollUpBtn=container.querySelector("[data-scroll-up]"),scrollDownBtn=container.querySelector("[data-scroll-down]");scrollUpBtn&&(scrollUpBtn.disabled=0===newStartIndex),scrollDownBtn&&(scrollDownBtn.disabled=newStartIndex>=items.length-limit)}function initMegaMenuScrollableHandlers(){if(window.__megaMenuScrollableInitialized)return;window.__megaMenuScrollableInitialized=!0,document.addEventListener("click",event=>{if(!(event.target instanceof Element))return;const upBtn=event.target.closest("[data-scroll-up]"),downBtn=event.target.closest("[data-scroll-down]");if(!upBtn&&!downBtn)return;const container=upBtn?upBtn.closest("[data-scrollable-container]"):downBtn.closest("[data-scrollable-container]");container&&applyScrollableScroll(container,upBtn?"up":"down")});let lastScrollableWheelTime=0;document.addEventListener("wheel",event=>{if(!(event.target instanceof Element))return;const container=event.target.closest("[data-scrollable-container]");if(!container)return;if(event.preventDefault(),Math.abs(event.deltaY)<1)return;const now="undefined"!=typeof performance&&performance.now?performance.now():Date.now();now-lastScrollableWheelTime<400||(lastScrollableWheelTime=now,applyScrollableScroll(container,event.deltaY>0?"down":"up"))},{passive:!1})}window.__megaMenuReadMoreInitialized||(window.__megaMenuReadMoreInitialized=!0,document.addEventListener("click",event=>{if(!(event.target instanceof Element))return;const toggle=event.target.closest("[data-readmore-toggle]");if(!toggle)return;"A"===toggle.tagName&&event.preventDefault();const listId=toggle.getAttribute("aria-controls"),list=listId?document.getElementById(listId):toggle.closest("[data-readmore-list]");if(!list)return;const limitValue=list.getAttribute("data-readmore-limit"),limit=limitValue?parseInt(limitValue,10):10,nextExpanded=!("true"===list.getAttribute("data-readmore-expanded"));list.setAttribute("data-readmore-expanded",nextExpanded.toString()),toggle.setAttribute("data-readmore-expanded",nextExpanded.toString()),toggle.setAttribute("aria-expanded","false");const moreText=toggle.getAttribute("data-readmore-more")||"Show all",lessText=toggle.getAttribute("data-readmore-less")||"Show less",textSpan=toggle.querySelector(".mega-menu__read-more-text"),iconSpan=toggle.querySelector(".mega-menu__read-more-icon");textSpan&&(textSpan.textContent=nextExpanded?lessText:moreText),iconSpan&&(iconSpan.hidden=nextExpanded);let index=0;const items=list.querySelectorAll("[data-readmore-item]");for(const item of items)item instanceof HTMLElement&&(index>=limit&&(item.hidden=!nextExpanded),index+=1);toggle instanceof HTMLElement&&toggle.blur(),requestAnimationFrame(()=>{requestAnimationFrame(()=>{const headerMenu=toggle.closest("header-menu");headerMenu&&"function"==typeof headerMenu.updateSubmenuHeight&&headerMenu.updateSubmenuHeight()})})})),window.applyMegaMenuScrollableScroll=applyScrollableScroll,window.initMegaMenuScrollableHandlers=initMegaMenuScrollableHandlers,initMegaMenuScrollableHandlers(),document.addEventListener("perf-defer:hydrated",initMegaMenuScrollableHandlers);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu-list"] && !Shopify.designMode) return;
  try {
    if (!window.__megaMenuReadMoreInitialized) {
    window.__megaMenuReadMoreInitialized = true;

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const toggle = event.target.closest('[data-readmore-toggle]');
      if (!toggle) return;
      if (toggle.tagName === 'A') {
        event.preventDefault();
      }

      const listId = toggle.getAttribute('aria-controls');
      const list = listId ? document.getElementById(listId) : toggle.closest('[data-readmore-list]');
      if (!list) return;

      const limitValue = list.getAttribute('data-readmore-limit');
      const limit = limitValue ? parseInt(limitValue, 10) : 10;
      const expanded = list.getAttribute('data-readmore-expanded') === 'true';
      const nextExpanded = !expanded;

      list.setAttribute('data-readmore-expanded', nextExpanded.toString());
      toggle.setAttribute('aria-expanded', nextExpanded.toString());

      const moreText = toggle.getAttribute('data-readmore-more') || 'Show all';
      const lessText = toggle.getAttribute('data-readmore-less') || 'Show less';
      toggle.textContent = nextExpanded ? lessText : moreText;

      let index = 0;
      const items = list.querySelectorAll('[data-readmore-item]');
      for (const item of items) {
        if (!(item instanceof HTMLElement)) continue;
        if (index >= limit) {
          item.hidden = !nextExpanded;
        }
        index += 1;
      }

      // Recalculate mega menu panel height after show more/less (layout updates in next frame)
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const headerMenu = toggle.closest('header-menu');
          if (headerMenu && typeof headerMenu.updateSubmenuHeight === 'function') {
            headerMenu.updateSubmenuHeight();
          }
        });
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-banner-image"] && !Shopify.designMode) return;
  try {
    (function() {
    // Handle custom 2-image slider functionality
    const bannerSliders = document.querySelectorAll('.mobile-banner-slider');
    
    bannerSliders.forEach(function(slider) {
      const slidesContainer = slider.querySelector('.mobile-banner-slides');
      const prevArrow = slider.querySelector('.mobile-banner-arrow-prev');
      const nextArrow = slider.querySelector('.mobile-banner-arrow-next');
      const dots = slider.querySelectorAll('.mobile-banner-dot');
      const slides = slider.querySelectorAll('.mobile-banner-slide');
      
      if (!slidesContainer || slides.length !== 2) return;
      
      let currentSlide = 0;
      
      // Function to update slider state
      function updateSlider() {
        // Update slide position using transform
        // Each slide is 50% width, so we move by 50% per slide
        const translateX = currentSlide * -50;
        slidesContainer.style.transform = 'translateX(' + translateX + '%)';
        slidesContainer.setAttribute('data-current-slide', currentSlide);
        
        // Update arrow visibility
        if (currentSlide === 0) {
          // First slide: show right arrow, hide left arrow
          if (prevArrow) {
            prevArrow.style.display = 'none';
          }
          if (nextArrow) {
            nextArrow.style.display = 'flex';
          }
        } else if (currentSlide === 1) {
          // Second slide: show left arrow, hide right arrow
          if (prevArrow) {
            prevArrow.style.display = 'flex';
          }
          if (nextArrow) {
            nextArrow.style.display = 'none';
          }
        }
        
        // Update dots
        dots.forEach(function(dot, index) {
          if (index === currentSlide) {
            dot.classList.add('mobile-banner-dot-active');
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.classList.remove('mobile-banner-dot-active');
            dot.setAttribute('aria-current', 'false');
          }
        });
      }
      
      // Next slide function
      function nextSlide() {
        if (currentSlide < slides.length - 1) {
          currentSlide++;
          updateSlider();
        }
      }
      
      // Previous slide function
      function prevSlide() {
        if (currentSlide > 0) {
          currentSlide--;
          updateSlider();
        }
      }
      
      // Arrow click handlers
      if (nextArrow) {
        nextArrow.addEventListener('click', function(e) {
          e.preventDefault();
          nextSlide();
        });
      }
      
      if (prevArrow) {
        prevArrow.addEventListener('click', function(e) {
          e.preventDefault();
          prevSlide();
        });
      }
      
      // Dot click handlers
      dots.forEach(function(dot, index) {
        dot.addEventListener('click', function(e) {
          e.preventDefault();
          currentSlide = index;
          updateSlider();
        });
      });
      
      // Initialize
      updateSlider();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-facets-sticky-footer"] && !Shopify.designMode) return;
  try {
    // Add body class for sticky footer spacing and handle visibility
  (function() {
    const stickyFooter = document.querySelector('.mobile-facets-sticky-footer');
    if (!stickyFooter) return;

    // Add body class for spacing on mobile
    function updateBodyClass() {
      if (window.matchMedia('(max-width: 749px)').matches) {
        document.body.classList.add('has-mobile-facets-footer');
      } else {
        document.body.classList.remove('has-mobile-facets-footer');
      }
    }

    updateBodyClass();

    // Listen for resize
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    mobileQuery.addEventListener('change', updateBodyClass);

    // Hide sticky footer when any drawer is open
    function updateStickyFooterVisibility() {
      const filtersDrawer = document.querySelector('#filters-drawer[open]');
      const sortDrawer = document.querySelector('#drawer-mobile-sort-drawer dialog[open]');

      if (filtersDrawer || sortDrawer) {
        stickyFooter.style.display = 'none';
      } else {
        stickyFooter.style.display = '';
      }
    }

    // Watch for native filters drawer open/close
    const filtersDrawer = document.querySelector('#filters-drawer');
    if (filtersDrawer) {
      const observer = new MutationObserver(updateStickyFooterVisibility);
      observer.observe(filtersDrawer, { attributes: true, attributeFilter: ['open'] });
    }

    // Watch for sort drawer open/close
    const sortDrawerDialog = document.querySelector('#drawer-mobile-sort-drawer dialog');
    if (sortDrawerDialog) {
      const observer = new MutationObserver(updateStickyFooterVisibility);
      observer.observe(sortDrawerDialog, { attributes: true, attributeFilter: ['open'] });
    }

    document.addEventListener('dialog:open', updateStickyFooterVisibility);
    document.addEventListener('dialog:close', updateStickyFooterVisibility);

    // Show sticky footer after scrolling past the results list
    function updateScrollVisibility() {
      if (!mobileQuery.matches) {
        stickyFooter.classList.remove('mobile-facets-sticky-footer--visible');
        return;
      }

      const resultsList = stickyFooter.closest('results-list');
      if (!resultsList) return;

      const threshold = resultsList.getBoundingClientRect().top + window.scrollY;
      stickyFooter.classList.toggle(
        'mobile-facets-sticky-footer--visible',
        window.scrollY > threshold
      );
    }

    window.addEventListener('scroll', updateScrollVisibility, { passive: true });
    mobileQuery.addEventListener('change', updateScrollVisibility);

    // Initial checks after layout is ready
    updateStickyFooterVisibility();
    requestAnimationFrame(updateScrollVisibility);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-sort-drawer"] && !Shopify.designMode) return;
  try {
    // Handle sort option change and close drawer
  (function() {
    const sortInputs = document.querySelectorAll('.mobile-sort-drawer__input');
    
    sortInputs.forEach(input => {
      input.addEventListener('change', async (e) => {
        const sortValue = e.target.value;
        const selectedLabel = e.target.closest('.mobile-sort-drawer__option-label');
        
        // Remove selected class from all option labels
        const allLabels = document.querySelectorAll('.mobile-sort-drawer__option-label');
        allLabels.forEach(label => {
          label.classList.remove('selected');
        });
        
        // Add selected class to the clicked option label
        if (selectedLabel) {
          selectedLabel.classList.add('selected');
        }

        // Update the sticky footer sort button to show the newly selected option name
        const selectedName = e.target.closest('.mobile-sort-drawer__option')?.querySelector('.mobile-sort-drawer__label')?.textContent?.trim();
        const stickyFooterLabel = document.querySelector('[data-sort-selected-label]');
        if (stickyFooterLabel && selectedName) {
          stickyFooterLabel.textContent = selectedName;
        }
        
        // Find the facets-form-component on the page
        const facetsFormComponent = document.querySelector('facets-form-component');
        
        if (facetsFormComponent) {
          // Update any existing radio buttons in the form to maintain consistency
          const facetsForm = facetsFormComponent.querySelector('form[ref="facetsForm"]') || 
                            facetsFormComponent.querySelector('form');
          
          if (facetsForm) {
            // Update existing radio buttons to match the selected value
            const existingRadios = facetsForm.querySelectorAll('input[name="sort_by"][type="radio"]');
            existingRadios.forEach(radio => {
              radio.checked = radio.value === sortValue;
            });
            
            // Remove any duplicate hidden sort_by inputs (prevent duplicates)
            const hiddenInputs = facetsForm.querySelectorAll('input[name="sort_by"][type="hidden"]');
            hiddenInputs.forEach(hiddenInput => {
              hiddenInput.remove();
            });
          }
          
          // Close the drawer after 500ms delay
          setTimeout(async () => {
            const drawerComponent = document.querySelector('#drawer-mobile-sort-drawer');
            if (drawerComponent && typeof drawerComponent.closeDialog === 'function') {
              await drawerComponent.closeDialog();
            }
            
            // Trigger the filter update after drawer is fully closed
            // The radio button with form attribute will be included automatically
            if (typeof facetsFormComponent.updateFilters === 'function') {
              facetsFormComponent.updateFilters();
            }
          }, 500);
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-information-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const productInformation = document.querySelector('.product-information');
  const blocks = productInformation.querySelectorAll('.shopify-block');
  
  
  blocks.forEach(block => {
    handleBlankBlocks(block);

    const config = { childList: true };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        handleBlankBlocks(mutation.target);
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(block, config);

  });

  function handleBlankBlocks(block) {
    if (block.childElementCount == 0) {
      block.classList.add('hidden');
    }else{
      block.classList.remove('hidden');
    }
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["three-column-product-information-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const productInformation = document.querySelector('.product-information');
    const blocks = productInformation.querySelectorAll('.shopify-block');
    
    
    blocks.forEach(block => {
      handleBlankBlocks(block);
  
      const config = { childList: true };
  
      // Callback function to execute when mutations are observed
      const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          handleBlankBlocks(mutation.target);
        }
      };
  
      // Create an observer instance linked to the callback function
      const observer = new MutationObserver(callback);
  
      // Start observing the target node for configured mutations
      observer.observe(block, config);
  
    });
  
    function handleBlankBlocks(block) {
      if (block.childElementCount == 0) {
        block.classList.add('hidden');
      }else{
        block.classList.remove('hidden');
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
